import { ReactNode } from 'react';
import { CatButton } from '@blocks-react/components/Button';

interface DealerLocatorConfirmButtonProps {
  children: ReactNode;
  disabled?: boolean;
  form?: string;
  onClick?: () => void;
}

export const DealerLocatorConfirmButton = ({
  children,
  disabled = false,
  form,
  onClick,
}: DealerLocatorConfirmButtonProps) => (
  <CatButton
    form={form}
    type="submit"
    variant="primary"
    onClick={onClick}
    disabled={disabled}
  >
    {children}
  </CatButton>
);
